/* Petrol full-width band above the header on every setup sandbox page (APP-096). */
.banner {
  background: var(--brand-petrol);
  color: var(--white);
}

.inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  max-width: var(--container-max);
  min-height: 56px;
  margin: 0 auto;
  padding: 6px var(--content-gutter);
  font-size: 15px;
  line-height: 1.4;
}

.text {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 0;
}

.actions {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.action {
  display: inline-flex;
  align-items: center;
  min-height: var(--control-height);
  padding: 0 14px;
  border: 1px solid var(--white);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--white);
  font-family: var(--font-ui);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
}

.action:hover,
.action[data-hovered] {
  background: var(--white);
  color: var(--brand-petrol);
}

.action:focus-visible,
.action[data-focus-visible] {
  outline: 2px solid var(--white);
  outline-offset: 2px;
}

/* The sign-in splash: a compact line next to the button (the splash is full-bleed). */
.note {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  background: var(--brand-petrol);
  color: var(--white);
  font-size: 15px;
  line-height: 1.4;
}
